export const UNKNOWN = 'unknown';
export const APPLICATION = 'application';
export const BACK_OFFICE = 'back-office';
export const EXTERNAL = 'external';

export default {
    UNKNOWN,
    APPLICATION,
    BACK_OFFICE,
    EXTERNAL,
};



// WEBPACK FOOTER //
// src/constants/sources.js